// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-GiveawayTypeStep-module__root-ii1QB {
  position: relative;
  padding: 16px;
  transition: 100ms ease-in-out;
  transition-property: border-color, background-color, color;
  display: flex;
  flex-direction: row;
  background-color: var(--background-hover);
  border-color: var(--border-secondary);
  gap: 16px;
  align-items: center;
  box-shadow: var(--mantine-shadow-sm);
}

.nightbot-GiveawayTypeStep-module__root-ii1QB[data-checked] {
    border-color: var(--background-accent-secondary);
    background-color: var(--background-accent);
    color: var(--text-active);
  }

.nightbot-GiveawayTypeStep-module__root-ii1QB[data-checked] .nightbot-GiveawayTypeStep-module__description-WZBYC {
      color: var(--text-active-secondary);
    }

.nightbot-GiveawayTypeStep-module__root-ii1QB[data-checked] .nightbot-GiveawayTypeStep-module__iconContainer-nfrKa {
      border-color: inherit;
      background-color: var(--background-accent-secondary);
    }

.nightbot-GiveawayTypeStep-module__root-ii1QB:active {
  box-shadow: var(--mantine-shadow-outline);
}

.nightbot-GiveawayTypeStep-module__description-WZBYC {
  color: var(--text-secondary);
}

.nightbot-GiveawayTypeStep-module__indicator-rGj_1 {
  margin-left: auto;
}

.nightbot-GiveawayTypeStep-module__content-ko8FC {
  display: flex;
  gap: 0;
  flex-direction: column;
}

.nightbot-GiveawayTypeStep-module__iconContainer-nfrKa {
  display: grid;
  align-items: center;
  justify-items: center;
  place-items: center;
  aspect-ratio: 1;
  height: 100%;
  border-color: var(--border-secondary);
  border-radius: var(--mantine-radius-md);
  box-shadow: var(--mantine-shadow-sm);
  border-width: 1px;
  transition: 100ms ease-in-out;
  transition-property: border-color, background-color, color;
}

.nightbot-GiveawayTypeStep-module__radioGroupInner-KpP5U {
  display: flex;
  gap: 24px;
  flex-direction: column;
}

.nightbot-GiveawayTypeStep-module__icon-CNTCa {
  padding: 16px;
}

.nightbot-GiveawayTypeStep-module__subHeading-yLt7a {
  color: var(--text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/giveaways/GiveawayTypeStep.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,0DAA0D;EAC1D,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,oCAAoC;AAgBtC;;AAdE;IACE,gDAAgD;IAChD,0CAA0C;IAC1C,yBAAyB;EAU3B;;AARE;MACE,mCAAmC;IACrC;;AAEA;MACE,qBAAqB;MACrB,oDAAoD;IACtD;;AAIJ;EACE,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EAAnB,qBAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,qCAAqC;EACrC,uCAAuC;EACvC,oCAAoC;EACpC,iBAAiB;EACjB,6BAA6B;EAC7B,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".root {\n  position: relative;\n  padding: 16px;\n  transition: 100ms ease-in-out;\n  transition-property: border-color, background-color, color;\n  display: flex;\n  flex-direction: row;\n  background-color: var(--background-hover);\n  border-color: var(--border-secondary);\n  gap: 16px;\n  align-items: center;\n  box-shadow: var(--mantine-shadow-sm);\n\n  &[data-checked] {\n    border-color: var(--background-accent-secondary);\n    background-color: var(--background-accent);\n    color: var(--text-active);\n\n    .description {\n      color: var(--text-active-secondary);\n    }\n\n    .iconContainer {\n      border-color: inherit;\n      background-color: var(--background-accent-secondary);\n    }\n  }\n}\n\n.root:active {\n  box-shadow: var(--mantine-shadow-outline);\n}\n\n.description {\n  color: var(--text-secondary);\n}\n\n.indicator {\n  margin-left: auto;\n}\n\n.content {\n  display: flex;\n  gap: 0;\n  flex-direction: column;\n}\n\n.iconContainer {\n  display: grid;\n  place-items: center;\n  aspect-ratio: 1;\n  height: 100%;\n  border-color: var(--border-secondary);\n  border-radius: var(--mantine-radius-md);\n  box-shadow: var(--mantine-shadow-sm);\n  border-width: 1px;\n  transition: 100ms ease-in-out;\n  transition-property: border-color, background-color, color;\n}\n\n.radioGroupInner {\n  display: flex;\n  gap: 24px;\n  flex-direction: column;\n}\n\n.icon {\n  padding: 16px;\n}\n\n.subHeading {\n  color: var(--text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `nightbot-GiveawayTypeStep-module__root-ii1QB`,
	"description": `nightbot-GiveawayTypeStep-module__description-WZBYC`,
	"iconContainer": `nightbot-GiveawayTypeStep-module__iconContainer-nfrKa`,
	"indicator": `nightbot-GiveawayTypeStep-module__indicator-rGj_1`,
	"content": `nightbot-GiveawayTypeStep-module__content-ko8FC`,
	"radioGroupInner": `nightbot-GiveawayTypeStep-module__radioGroupInner-KpP5U`,
	"icon": `nightbot-GiveawayTypeStep-module__icon-CNTCa`,
	"subHeading": `nightbot-GiveawayTypeStep-module__subHeading-yLt7a`
};
export default ___CSS_LOADER_EXPORT___;
